import { CURRENCY_CODE, CURRENCY_SYMBOLS } from '@ps/utils';
import {
  CHILD_AGE_UNIT_CODE,
  QUALIFICATION_CODE,
} from '../../constants/qualification.constants';
import { toChildAgeGenderLabel } from '../../mappers/child-age-gender-lib.adapter';
import { QuotaCriteria, QuotaRangeSet } from '../../models/survey-quota.model';

export function formatCurrencyRange(rangeItem: QuotaRangeSet): string {
  const symbol = CURRENCY_SYMBOLS[rangeItem.units] ?? '';
  const isPrefixCurrency =
    rangeItem.units >= CURRENCY_CODE.US && rangeItem.units <= CURRENCY_CODE.AU;

  return isPrefixCurrency
    ? `${symbol}${rangeItem.from} - ${symbol}${rangeItem.to}`
    : `${rangeItem.from} ${symbol} - ${rangeItem.to} ${symbol}`;
}

/**
 * The display labels a single criterion contributes — one entry per condition
 * name or range set. Callers that want one line per criterion (the flagged-quota
 * drawer) read this directly; `generateQuotaTitle` joins it into one string.
 */
export function quotaCriterionLabels(criterion: QuotaCriteria): string[] {
  const labels: string[] = [];

  if (criterion.qualificationCode === QUALIFICATION_CODE.CHILD_AGE_GENDER) {
    labels.push(
      toChildAgeGenderLabel(
        criterion.conditionCodes?.map(Number) ?? [],
        criterion.childAgeUnit ?? CHILD_AGE_UNIT_CODE.YEARS,
      ),
    );
  } else if (criterion.conditionNames?.length && !criterion.rangeSets?.length) {
    labels.push(...criterion.conditionNames);
  }

  if (criterion.rangeSets?.length) {
    labels.push(...criterion.rangeSets.map(formatCurrencyRange));
  }

  return labels;
}

export function generateQuotaTitle(input: QuotaCriteria[]): string {
  return input.flatMap(quotaCriterionLabels).join(',');
}
